document.addEventListener('DOMContentLoaded', function () {
  const logoSliderSection = document.querySelector('.logo-slider');
  if(!logoSliderSection) return;
  const stars = document.querySelectorAll('.logo-slider .stars');

  stars.forEach(star => {
    const rating = parseFloat(star.getAttribute('rating')) || 0;
    const percent = (rating / 5) * 100;
    star.style.setProperty('--percent', `${percent}%`);
  });
});

